import { deletePreviewCfg } from "@/utils";
import { Archive, ArrowUpFromLine, ChevronDown, ChevronUp, CircleDollarSign, Newspaper, Plus, Settings, TriangleAlert, Users } from "lucide-react";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import "./Menu.scss";

type Props = {
    children: ReactNode,
    isArchiveOpen: boolean,
    isOnline: boolean,
    updateAvailable: boolean,
    setArchiveOpen: React.Dispatch<React.SetStateAction<boolean>>
    handleMigrate: () => Promise<void>
}

export const Menu = ({ children, isArchiveOpen, isOnline, updateAvailable, setArchiveOpen, handleMigrate }: Props) => (
    <div className="container">
        <div className="header">
            <nav className="header__nav">
                <div className='header__links'>
                    <Link className="header__link add-invoice" to="/" onClick={deletePreviewCfg}>
                        <Plus width={20} height={20} />Create Invoice
                    </Link>
                </div>
            </nav>
        </div>
        <div className="content">
            <div className="content__side-menu">
                <ul className="content__links-list">
                    <li className="content__list-item">
                        <Link className={`side-link ${location.pathname === "/history" ? "active-side" : ""}`} to="/history">
                            <Newspaper width={24} height={24} />
                            Invoices
                        </Link>
                    </li>
                    <li className="content__list-item">
                        <Link className={`side-link ${location.pathname === "/transactions" ? "active-side" : ""}`} to="/transactions">
                            <CircleDollarSign width={24} height={24} />
                            Transactions
                        </Link>
                    </li>
                    <li className="content__list-item">
                        <Link className={`side-link ${location.pathname === "/customers" ? "active-side" : ""}`} to="/customers">
                            <Users width={24} height={24} />
                            Customers
                        </Link>
                    </li>
                    <li className="content__list-item">
                        <Link className={`side-link ${location.pathname === "/settings" ? "active-side" : ""}`} to="/settings">
                            <Settings width={24} height={24} />
                            Settings
                        </Link>
                    </li>
                    <li className="content__list-item">
                        <button className='side-link side-button' onClick={() => {
                            setArchiveOpen(!isArchiveOpen);
                        }}>
                            <span className={`${location.pathname.split("/")[1] === "archive" ? "active-side" : ""}`}>
                                <Archive width={24} height={24} />
                                Archive
                            </span>
                            {isArchiveOpen ? <ChevronUp /> : <ChevronDown />}
                        </button>
                        {isArchiveOpen && <ul className="content__secondary-list">
                            <li className="content__secondary-list-item">
                                <Link className={`content__secondary-link ${location.pathname.split("/")[2] === "invoices" ? "active-side" : ""}`}
                                    to="/archive/invoices">
                                    Invoices
                                </Link>
                            </li>
                            <li className="content__secondary-list-item">
                                <Link className={`content__secondary-link ${location.pathname.split("/")[2] === "customers" ? "active-side" : ""}`}
                                    to="/archive/customers">
                                    Customers
                                </Link>
                            </li>
                        </ul>}
                    </li>
                </ul>
                <div className="content__warnings">
                    {updateAvailable && <div className="content__update">
                        <button className="content__update-button" onClick={() => {
                            handleMigrate()                
                        }}>
                            Update version <ArrowUpFromLine width={20} height={20} />
                        </button>
                    </div>}
                    {!isOnline &&
                        <div className="content__offline-warning">
                            <span>
                                <TriangleAlert width={20} height={20} />
                                Offline mode
                            </span>
                        </div>}
                </div>
            </div>
            <div className="content__components">
                {children}
            </div>
        </div>
    </div>
);